
import { PainelEtapaBase } from "components/PaineisAvaliacaoEtapas/PainelAvaliacaoBase";
import { AvaliacaoPreRequisitos } from "components/PaineisAvaliacaoEtapas/AvaliacaoPreRequisitos";

interface UseAvaliacaoReturn {
  ComponenteEtapa: React.FC<any>;
}

export const useAvaliacaoPorEtapa = (etapaNome: string): UseAvaliacaoReturn => {

  switch (etapaNome) {
    case "Requisitos":
      return {
        ComponenteEtapa: AvaliacaoPreRequisitos
      };

    default:
      return {
        ComponenteEtapa: PainelEtapaBase
      };
  }
};

